if (!customElements.get('career-form')) {
  const MODAL_SHOWN = 'shown';
  const SELECTOR_TRIGGER = '[data-career-modal-target]';

  class CareerForm extends HTMLElement {
    constructor() {
      super();
      
      this.openModal = null;
      this.boundHandleClick = this.handleClick.bind(this);
    }

    connectedCallback() {
      document.addEventListener('click', this.boundHandleClick);
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.boundHandleClick);

      if (this.openModal) {
        this.closeModal(this.openModal);
        this.openModal = null;
      }
    }

    open(modalEl) {
      if (!modalEl) return;
      this.openModal = modalEl;

      modalEl.classList.add(MODAL_SHOWN);
      modalEl.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }

    closeModal(modalEl) {
      if (!modalEl) return;
      if (this.openModal === modalEl) this.openModal = null;

      modalEl.classList.remove(MODAL_SHOWN);
      modalEl.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    handleTriggerClick(e) {
      const trigger = e.target.closest(SELECTOR_TRIGGER);
      const id = trigger?.getAttribute('data-career-modal-target');
      if (!id) return;

      const modal = document.getElementById(id);
      if (modal) this.open(modal);
    }

    handleOverlayClick(e) {
      const modal = e.target;
      if (!modal || !modal.classList.contains(MODAL_SHOWN)) return;

      this.closeModal(modal);
      this.openModal = null;
    }

    handleClick(e) {
      this.handleTriggerClick(e);
      this.handleOverlayClick(e);
    }
  }

  customElements.define('career-form', CareerForm);
}
